import React from "react";
import { cn } from "../ui";

const AVATAR_TONE = {
  advisor: "tw-bg-accent-tint tw-text-text-accent",
  client: "tw-bg-surface-selected tw-text-text",
  you: "tw-bg-surface-selected tw-text-text",
  system: "tw-bg-surface-sunken tw-text-text-muted",
};

// A role-coloured square with initials (thread transcript spec § Avatar). With
// a `src` the photo fills the same square instead; nothing passes one yet —
// the message payload carries no photo.
export default function Avatar({
  initials,
  role,
  src = null,
  size = 32,
  className = "",
}) {
  return (
    <span
      data-slot="thread-avatar"
      data-role={role}
      className={cn(
        "tw-grid tw-shrink-0 tw-place-items-center tw-overflow-hidden tw-rounded-md tw-text-xs tw-font-bold",
        AVATAR_TONE[role] || AVATAR_TONE.advisor,
        className,
      )}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {typeof src === "string" && src ? <img src={src} alt="" className="tw-h-full tw-w-full tw-object-cover" /> : initials}
    </span>
  );
}
